module.exports = __webpack_public_path__ + "media/images/morethan 10 users-eec2df52.png";